module.exports = __webpack_public_path__ + "img/1-3.f6606cc7.svg";